document.addEventListener("DOMContentLoaded", () => {
    // Εντοπίζει τα links των Account, Search και Cart
    const links = document.querySelectorAll('a[href="/account"], a[href="/search"], a[href="/cart"]');
    
    // Προσθέτει το rel="nofollow" σε κάθε link
    links.forEach(link => {
        link.setAttribute("rel", "nofollow");
    });
});
